webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__header_vue__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('headercomponent', __WEBPACK_IMPORTED_MODULE_1__header_vue___default.a);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Home__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: [{
		path: '/',
		name: 'Home',
		component: __WEBPACK_IMPORTED_MODULE_2__pages_Home___default.a
	}]
}));

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(25)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(30),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (num, base) {
	var n = num;
	var numWithBase = n.toString(base);
	return numWithBase;
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getFibonacciNumbersList_js__ = __webpack_require__(11);


/* harmony default export */ __webpack_exports__["a"] = (function (n, fibonacciNumbersList) {
	fibonacciNumbersList = [0, 1];

	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getFibonacciNumbersList_js__["a" /* default */])(0, 1, n + 1, fibonacciNumbersList);

	var l = fibonacciNumbersList.length;
	var fibNumPositions = [];
	var fibNumPositionsString = '';

	for (var i = 0; i < l; i++) {
		if (fibonacciNumbersList[i] === n) {
			fibNumPositions.push(i + 1);
			fibNumPositionsString += fibNumPositionsString === '' ? i + 1 : ', ' + (i + 1);
		}
	}
	if (fibNumPositions.length) {
		return {
			value: fibNumPositionsString + '<sup>th</sup>',
			symbol: '࿓'
		};
	} else {
		return {
			value: null,
			symbol: ''
		};
	}
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (v7, v13) {
	var v14 = void 0,
	    v15 = void 0,
	    v16 = void 0;
	v14 = v7;
	v16 = Math.round(v7 / v13);
	while (v13 <= v16) {
		v15 = v7 / v13;
		v16 = Math.round(v15);
		if (v15 === v16) {
			v14 = v13;
			return v14;
		}
		v13 = v13 + 2;
	}
	return v14;
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (v7, v9) {
	var v12 = 1;
	for (var i = 0; i < v9; i++) {
		v12 = v12 * v7;
	}
	return v12;
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (n) {
	var a = 0;
	var fac = 1;
	this.factorialList = [];

	while (fac < n + 1) {
		a = a + 1;
		fac *= a;
		this.factorialList.push(fac);
	}

	var l = this.factorialList.length;

	for (var i = 0; i <= l; i++) {
		if (this.factorialList[i] === n) {
			return {
				value: i + 1,
				symbol: '!'
			};
		}
	}

	return {
		value: '',
		symbol: ''
	};
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__power_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__divider_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getPrimeNumbersList_js__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["a"] = (function (n, primeNumbersList) {
	var v1 = void 0,
	    v2 = void 0,
	    v3 = void 0,
	    v4 = void 0,
	    v5 = void 0,
	    v6 = void 0;
	v1 = n;

	v2 = v1;
	if (v1 === 1) {
		return {
			value: '1<sup> </sup>',
			symbol: '·'
		};
	}

	if (v2 < 2) {
		return {
			value: '-',
			symbol: '-'
		};
	}

	v4 = v1 / 2;
	v5 = '';
	v6 = 3;

	if (v4 === Math.round(v4)) {
		v3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__power_js__["a" /* default */])(v2, 2);
		if (v3 === 1) {
			v5 = v5 + '2';
		} else {
			v5 = v5 + '2<sup>' + v3 + '</sup>';
		}
		v1 = v1 / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(2, v3);
	} else {
		v4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__divider_js__["a" /* default */])(v1, v6);
		v3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__power_js__["a" /* default */])(v1, v4);
		v6 = v4;
		v1 = v1 / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(v4, v3);
		if (v3 === 1) {
			v5 = v5 + v4;
		} else {
			v5 = v5 + v4 + '<sup>' + v3 + '</sup>';
		}
	}
	while (v6 <= v1) {
		v4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__divider_js__["a" /* default */])(v1, v6);
		v3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__power_js__["a" /* default */])(v1, v4);
		if (v3 === 1) {
			v5 = v5 + ' · ' + v4;
		} else {
			v5 = v5 + ' · ' + v4 + '<sup>' + v3 + '</sup>';
		}
		v6 = v4;
		v1 = v1 / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(v4, v3);
	}
	if (v5 === 'NaN<sup>0</sup>') {
		console.log('Введите число.');
		return;
	}
	if (v5 * 1 === v2) {
		var primeNumberList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__getPrimeNumbersList_js__["a" /* default */])(n, primeNumbersList);
		v5 = {
			value: primeNumberList.length + '<sup>th</sup> ',
			symbol: '⁚'
		};
	} else {
		v5 = {
			value: v5,
			symbol: '⁞'
		};
	}
	return v5;
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fib;
function fib(a, b, n, fibonacciNumbersList) {
	var c = a + b;
	if (c < n) {
		a = b;
		b = c;
		fibonacciNumbersList.push(c);
		return fib(a, b, n, fibonacciNumbersList);
	}
}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (n, primeNumbersList) {
	var S = [];
	primeNumbersList = [];

	S[1] = 0;
	for (var k = 2; k <= n; k++) {
		S[k] = k;
	}

	for (var m = 2; m * m <= n; m++) {
		if (S[m] > 1) {
			for (var l = m * m; l <= n; l += m) {
				S[l] = 0;
			}
		}
	}
	for (var i = 2; i <= n; i++) {
		if (S[i] > 0) {
			primeNumbersList.push(S[i]);
		}
	}

	return primeNumbersList;
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__oddEven_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__factorization_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__detectFibonacciNumber_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__factorial_js__ = __webpack_require__(9);






/* harmony default export */ __webpack_exports__["a"] = ({
	base: __WEBPACK_IMPORTED_MODULE_0__base_js__["a" /* default */],
	oddEven: __WEBPACK_IMPORTED_MODULE_1__oddEven_js__["a" /* default */],
	factorization: __WEBPACK_IMPORTED_MODULE_2__factorization_js__["a" /* default */],
	factorial: __WEBPACK_IMPORTED_MODULE_4__factorial_js__["a" /* default */],
	detectFibonacciNumber: __WEBPACK_IMPORTED_MODULE_3__detectFibonacciNumber_js__["a" /* default */]

});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (num) {
	if (num % 2 === 0) {
		return {
			'value': '2 · ' + num / 2,
			'symbol': '◑'
		};
	} else {
		return {
			'value': '2 · ' + Math.round(num / 2 - 1) + ' + 1',
			'symbol': '◐'
		};
	}
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (v7, v8) {
	var v9 = 0;
	var v10 = 0;
	var v11 = 0;
	v11 = Math.round(v7 / v8);
	for (var i = 1; i <= v11; i++) {
		v10 = v7 / v8;
		if (v10 !== Math.round(v10)) {
			return v9;
		}
		v9 = v9 + 1;
		v7 = v10;
	}
	return v9;
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
	components: __WEBPACK_IMPORTED_MODULE_3__components__["default"],
	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
	}
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app'
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'headercomponent',
	data: function data() {
		return {
			menu: [{
				txt: 'Odd/Event',
				status: true
			}, {
				txt: 'Base',
				status: true,
				subMenu: [{}]
			}]
		};
	}
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_formulas__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			numbers: [],
			repeat: null,
			number: '',
			primeList: [],
			fibList: [0, 1],
			factorialList: [],
			settingBtnOpen: false,

			showSettings: false,
			showFib: true
		};
	},
	mounted: function mounted() {
		var nums = JSON.parse(localStorage.getItem('numbers'));
		console.log(nums);
		if (nums !== null) {
			if (nums.length) {
				this.numbers = nums;
			}
		}
	},


	methods: {
		calculate: function calculate() {
			var _this = this;

			var checkIfRepeatNum = this.numbers.filter(function (item) {
				return item.title.value === _this.number;
			});

			if (this.number === '') {
				console.log('it is null');
				this.showPopup('Nice try, but service work with whole numbers');
				this.number = null;
			}
			if (this.number && checkIfRepeatNum.length === 0) {
				console.time('calculating exec time');

				var curNum = this.number * 1;
				var num = {};

				num['title'] = {
					'value': this.number,
					'symbol': ''
				};

				num['base2'] = {
					'value': __WEBPACK_IMPORTED_MODULE_1__assets_formulas__["a" /* default */].base(curNum, 2),
					'symbol': 'x<sub>2</sub>'
				};

				num['base8'] = {
					'value': __WEBPACK_IMPORTED_MODULE_1__assets_formulas__["a" /* default */].base(curNum, 8),
					'symbol': 'x<sub>8</sub>'
				};

				num['base32'] = {
					'value': __WEBPACK_IMPORTED_MODULE_1__assets_formulas__["a" /* default */].base(curNum, 32),
					'symbol': 'x<sub>32</sub>'
				};

				num['oddEven'] = __WEBPACK_IMPORTED_MODULE_1__assets_formulas__["a" /* default */].oddEven(curNum);

				num['factorization'] = __WEBPACK_IMPORTED_MODULE_1__assets_formulas__["a" /* default */].factorization(curNum, this.primeList);

				if (this.showFib) {
					num['detectFib'] = __WEBPACK_IMPORTED_MODULE_1__assets_formulas__["a" /* default */].detectFibonacciNumber(curNum, this.fibList);
				}

				num['factorial'] = __WEBPACK_IMPORTED_MODULE_1__assets_formulas__["a" /* default */].factorial(curNum, this.factorialList);

				this.numbers.push(num);

				localStorage.setItem('numbers', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.numbers));

				this.number = null;

				console.timeEnd('calculating exec time');
			} else {
				this.repeat = this.number;
				this.number = null;
				setTimeout(function () {
					_this.repeat = null;
				}, 1000);
			}
		},
		numberDelete: function numberDelete(n) {
			this.numbers.splice(n, 1);
			localStorage.setItem('numbers', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.numbers));
		},
		showPopup: function showPopup(msg) {
			alert(msg);
		},
		toggleSettings: function toggleSettings() {
			this.showSettings = !this.showSettings;
		}
	}
});

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(24)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(29),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(23)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(28),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "number_field",
    class: {
      top: _vm.numbers.length
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    staticClass: "inp",
    attrs: {
      "type": "number",
      "maxlength": "7",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.calculate()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('div', {
    staticClass: "settings__container",
    style: ({
      backgroundColor: _vm.showSettings ? 'white' : 'transparent'
    })
  })]), _c('div', {
    staticClass: "res"
  }, _vm._l((_vm.numbers), function(num, index) {
    return _c('div', {
      staticClass: "num",
      class: ['_' + num.title.value, {
        'bounce': num.title.value == _vm.repeat
      }]
    }, [_c('span', {
      staticClass: "num__delete",
      on: {
        "click": function($event) {
          _vm.numberDelete(index)
        }
      }
    }, [_vm._v("×")]), _vm._l((num), function(value, key) {
      return (value.value) ? _c('div', {
        class: key
      }, [_c('span', {
        staticClass: "num__symbol",
        domProps: {
          "innerHTML": _vm._s(value.symbol)
        }
      }, [_c('br')]), _c('span', {
        staticClass: "num__value",
        domProps: {
          "innerHTML": _vm._s(value.value)
        }
      })]) : _vm._e()
    })], 2)
  }))])
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('ul', {
    staticClass: "header__menu"
  }), _vm._v(" "), _c('a', {
    staticClass: "logo"
  }, [_vm._v("Numb"), _c('sup', [_vm._v("e")]), _vm._v("r the"), _c('sub', [_vm._v("o")]), _vm._v("R(y)")])])
}]}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('headercomponent'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ })
],[16]);


// WEBPACK FOOTER //
// static/js/app.16edb315a45ddd31a621.js